import React from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/chat-header/search.svg';
import { ReactComponent as Close } from '../../../assets/images/search_close.svg';
import PropTypes from 'prop-types';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
  }


  /**
   * Following the states used in Search Component.
   *
   */
  state = { isTyping: false }
  /**
  * Following the states used in Search Component.
  *
  * @param {object} event to handle the searched element.
  */
  searchFilterList = () => {
    const searchInput = this.searchInputRef.current;
    const value = searchInput ? searchInput.value : '';
    const { handleSearchFilterList } = this.props
    const searchWith = value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"); // NOSONAR
    this.setState({
      isTyping: value
    })
    handleSearchFilterList(searchWith)
  }

  /**
   * clear search field
   */
  clearSearch = () => {
    const searchInput = this.searchInputRef.current;
    if (searchInput) {
      searchInput.value = '';
      this.searchFilterList();
    }
  }

  /**
   * render() method to render the Search component into browser.
   */
  render() {
    const { isTyping } = this.state
    return (
      <div className={`search-container ${isTyping ? "typingValue" : ""}`}>
        <div className='search'>
          <i className="Search" title="Search"> <SearchIcon /></i>
          <input ref={this.searchInputRef} type="text" className="search-contacts" name="search-contacts" autoComplete="off" placeholder="Search" onChange={this.searchFilterList}></input>
          <i className={(this.state.isTyping) ? 'CloseSearch' : ''} title="Clear search"
          onClick={this.clearSearch}
          onKeyDown={(e) => e.key === 'Enter' && this.clearSearch}
          tabIndex="0"
          role="button"
          >{isTyping && <Close />}</i>
        </div>
      </div>
    );
  }
}

export default Search;

Search.propTypes = {
  handleSearchFilterList: PropTypes.func,
};
